'use strict';

var React = require('react');
var component$1 = require('../CellTextSub/component.js');
var index = require('../Flex/index.js');
var component = require('../HighlightedIcon/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const CellPictoTextSub = React.forwardRef(({ text, icon, iconColor, sub, size = 'm', textMaxWidth, textOverflow, ...props }, ref) => (React__default.default.createElement(index.Flex.Row, { ...props, space: "s", ref: ref, alignItems: "center" },
    React__default.default.createElement(component.HighlightedIcon, { color: iconColor, name: icon }),
    React__default.default.createElement(component$1.CellTextSub, { text: text, sub: sub, size: size, textOverflow: textOverflow, maxWidth: textMaxWidth }))));

exports.CellPictoTextSub = CellPictoTextSub;
//# sourceMappingURL=component.js.map
